export function shorten(value: string, head = 4, tail = 4): string {
  if (value.length <= head + tail + 2) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}

export function formatCompact(value: number, maximumFractionDigits = 2): string {
  if (!Number.isFinite(value)) return "—";
  return new Intl.NumberFormat("en-US", {
    notation: Math.abs(value) >= 10_000 ? "compact" : "standard",
    maximumFractionDigits,
  }).format(value);
}

export function formatUsd(value?: number): string {
  if (value === undefined || !Number.isFinite(value) || value < 0) return "$—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: value >= 10_000 ? "compact" : "standard",
    maximumFractionDigits: value >= 10_000 ? 1 : 2,
  }).format(value);
}

export function formatPrice(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return "—";
  if (value >= 0.01) return value.toLocaleString("en-US", { maximumFractionDigits: 6 });
  return value.toLocaleString("en-US", {
    minimumSignificantDigits: 3,
    maximumSignificantDigits: 5,
  });
}

export function formatTokenAmount(raw: bigint, decimals: number, max = 6): string {
  const scale = 10n ** BigInt(decimals);
  const whole = raw / scale;
  const fraction = raw % scale;
  if (max === 0 || fraction === 0n) return whole.toLocaleString("en-US");
  const digits = fraction.toString().padStart(decimals, "0").slice(0, max).replace(/0+$/, "");
  return digits ? `${whole.toLocaleString("en-US")}.${digits}` : whole.toLocaleString("en-US");
}

export function parseUnits(value: string, decimals: number): bigint {
  const normalized = value.trim().replace(",", ".");
  if (!/^\d*(?:\.\d*)?$/.test(normalized) || normalized === "" || normalized === ".") {
    throw new Error("Enter a valid amount");
  }
  const [whole = "0", fraction = ""] = normalized.split(".");
  if (fraction.length > decimals) throw new Error(`Maximum ${decimals} decimal places`);
  return BigInt(whole || "0") * 10n ** BigInt(decimals) + BigInt(fraction.padEnd(decimals, "0") || "0");
}

export function formatDate(timestamp?: number): string {
  if (!timestamp) return "—";
  return new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(timestamp * 1_000));
}
